



import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { connect } from 'react-redux';
import moment from 'moment';
import Messages from '../../../shared/UI/Messages/Messages';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import * as actions from '../../../store/actions/index';



class AddRecipe extends Component {
  state = {
    type: 'add',

    // invRecipe fields
    recipeId: null,
    menuItemId: null,
    recipeVersion: '',
    effectiveDate: null,

    // invRecipeDetail rows
    recipeDetailRows: [
      { id: Date.now(), recipeDetailId: null, ingredientId: null, area: null, quantity: null, uomid: null },
    ],

    // Meta
    companyId: this.props.loggedUserDetail.CompanyId,
    createdBy: this.props.loggedUserDetail.empID,
    createdDate: new Date(),
    touch: false,

    // Menu Item With Menu Components Details (display only)
    menuDetailExpanded: true,
  };

  componentDidMount() {
    this.getAccess = HASACCESS(USER_SUBMENU_ID);
    let id = this.props.match.params.id;
    let type = this.props.match.params.type;

    this.props.getMasterTableList(
      `res/GetInvRecipebyid?recipeid=${id}`,
      this.props.loggedUserDetail.CompanyId
    );
    this.props.getMasterKeywordList('MenuItem');
    this.props.getMasterKeywordList('Ingredient');
    this.props.getMasterKeywordList('area');
    this.props.getMasterKeywordList('uom');
    this.props.getMasterKeywordList('MenuComponent');

    if (type !== 'add') {
      this.timer();
    }
  }

  timer = () => {
    this.intervalID = setInterval(() => {
      this.fetchSingleProcess();
    }, 1000);
  };

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  fetchSingleProcess = () => {
    let type = this.props.match.params.type;

    if (this.props.tableLists && this.props.tableLists.invRecipe) {
      const data = this.props.tableLists;
      clearInterval(this.intervalID);

      const d = data.invRecipe;
      const detailRows =
        data.invRecipeDetail && data.invRecipeDetail.length > 0
          ? data.invRecipeDetail.map((r) => ({
              id: Date.now() + Math.random(),
              recipeDetailId: r.recipeDetailId,
              ingredientId: r.ingredientId,
              area: r.area,
              quantity: r.quantity,
              uomid: r.uomid,
            }))
          : [{ id: Date.now(), recipeDetailId: null, ingredientId: null, area: null, quantity: null, uomid: null }];

      this.setState({
        type,
        recipeId: d.recipeId,
        menuItemId: d.menuItemId,
        recipeVersion: d.recipeVersion || '',
        effectiveDate: d.effectiveDate ? new Date(d.effectiveDate) : null,
        recipeDetailRows: detailRows,
      });

      this.fetchMenuItemDetails(d.menuItemId);
    }
  };

  fetchMenuItemDetails = (id) => {
    if (id === null || id === undefined || id === '') return;
    this.props.getMasterTableList(
      `res/GetInvMenuItembyid?MenuItemId=${id}`,
      this.state.companyId
    );
  };

  onMenuItemChange = (e) => {
    this.setState({ menuItemId: e.value, touch: true });
    this.fetchMenuItemDetails(e.value);
  };

  toggleMenuDetail = () => {
    this.setState((prev) => ({ menuDetailExpanded: !prev.menuDetailExpanded }));
  };

  getMenuItemDetail = () => {
    const { menuItemId } = this.state;
    const data = this.props.tableLists;
    if (menuItemId === null || menuItemId === undefined || !data || !data.invMenuItem) return null;
    // tableLists is shared with other API calls — only show the response for the selected menu item
    if (String(data.invMenuItem.menuItemId) !== String(menuItemId)) return null;

    const optionLabel = (list, value) => {
      const opt = (list || []).find((o) => String(o.value) === String(value));
      return opt ? opt.label : null;
    };

    const rows = data.resmenucomponentlist || data.invDefineComponentformenulist || [];
    const components = rows
      .map((r) => {
        const compId = r.menuComponentId ?? r.menuComponent;
        return (
          r.menuComponentName ??
          r.componentName ??
          optionLabel(this.props.menuComponentList, compId) ??
          compId
        );
      })
      .filter((n) => n !== null && n !== undefined && n !== '');

    return {
      menuItemName:
        data.invMenuItem.menuName ?? optionLabel(this.props.menuItemList, menuItemId) ?? '',
      components,
    };
  };

  add = () => {
    const s = this.state;

    if (!s.effectiveDate) {
      this.growl.show({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Effective Date is required.',
        sticky: true,
      });
      return;
    } 

    const payload = {
      InvRecipe: {
        MenuItemId: s.menuItemId,
        RecipeVersion: s.recipeVersion,
        EffectiveDate: s.effectiveDate ? moment(s.effectiveDate).format('YYYY-MM-DD') : null,
        Companyid: s.companyId,
        ...(s.type === 'add'
          ? {
              Createdby: s.createdBy,
              Createddate: moment().format('YYYY-MM-DD'),
            }
          : {
              Updatedby: s.createdBy,
              Updateddate: moment().format('YYYY-MM-DD'),
            }),
      },
      invRecipeDetail: s.recipeDetailRows.map(({ recipeDetailId, ingredientId, area, quantity, uomid }) => ({
        ...(recipeDetailId ? { recipeDetailId } : {}),
        ingredientId,
        area,
        quantity,
        uomid,
        companyid: s.companyId,
        recipeId: s.recipeId || '',
      })),
    };

    if (s.type === 'edit') {
      payload.InvRecipe.recipeId = s.recipeId;
    }

    this.props.processDynamicData('invRecipe', s.type, payload, 'res/GeInvRecipeList?companyId=' + s.companyId);
  };

  resetData = () => {
    this.setState({
      type: 'add',
      recipeId: null,
      menuItemId: null,
      recipeVersion: '',
      effectiveDate: null,
      recipeDetailRows: [
        { id: Date.now(), recipeDetailId: null, ingredientId: null, area: null, quantity: null, uomid: null },
      ],
      touch: false,
    });
  };

  // ── Recipe Detail Row Helpers ──────────────────────────────────────────────

  addDetailRow = () => {
    this.setState((prev) => ({
      recipeDetailRows: [
        ...prev.recipeDetailRows,
        { id: Date.now(), recipeDetailId: null, ingredientId: null, area: null, quantity: null, uomid: null },
      ],
      touch: true,
    }));
  };

  deleteDetailRow = (rowId) => {
    this.setState((prev) => ({
      recipeDetailRows: prev.recipeDetailRows.filter((r) => r.id !== rowId),
      touch: true,
    }));
  };

  updateDetailRow = (rowId, field, value) => {
    this.setState((prev) => ({
      recipeDetailRows: prev.recipeDetailRows.map((r) =>
        r.id === rowId ? { ...r, [field]: value } : r
      ),
      touch: true,
    }));
  };

  render() {
    if (this.props.success) {
      REDIRECT_TO_URL('/Recipe/', this.props);
    }

    let addAccess = true;
    let editAccess = true;
    if (this.getAccess !== undefined) {
      if (
        this.getAccess.viewAccess === false &&
        this.props.userDetail &&
        this.props.userDetail.userId !== this.props.match.params.id
      ) {
        this.props.history.push('/dashboard');
      }
      addAccess = this.getAccess.addAccess === true;
      editAccess = this.getAccess.editAccess === true;
    }
    let accessButton = { addAccess, editAccess };

    const isEnabled = this.state.touch === true;
    const menuDetail = this.getMenuItemDetail();

    let redirectURL = '/Recipe/';
    if (this.props.userDetail && this.props.match.params.id !== undefined) {
      if (this.props.userDetail.userId === this.props.match.params.id) {
        redirectURL = '/dashboard';
      }
    }


    

    return (
      <div className="p-grid">
        {this.props.loading && <div className="page-loader"></div>}
        {this.props.error !== null && <Messages type="error" message={this.props.error} />}
        {this.props.success !== null && <Messages type="success" message={this.props.success} />}
        <Toast ref={(el) => (this.growl = el)} />

        <div className="p-col-12">
          <div className="card card-w-title" style={{ position: 'relative' }}>
            <h1>{this.state.type} Recipe</h1>

            <div className="p-grid mt1">

              {/* ── RECIPE HEADER ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Recipe Info</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">
                        Menu Item <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={this.props.menuItemList}
                          value={this.state.menuItemId}
                          onChange={this.onMenuItemChange}
                          placeholder="Select Menu Item"
                          name="menuItemId"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Recipe Version</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="recipeVersion"
                          value={this.state.recipeVersion}
                          onChange={(e) => this.setState({ recipeVersion: e.target.value, touch: true })}
                          placeholder="Recipe Version (e.g. 1)"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Effective Date</label>
                      <div className="mt1">
                        <Calendar
                        //   className="p-col-12"
                          value={this.state.effectiveDate}
                          onChange={(e) => this.setState({ effectiveDate: e.value, touch: true })}
                          placeholder="Select Effective Date"
                          dateFormat="dd/mm/yy"
                        //   showIcon
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* ── MENU ITEM WITH MENU COMPONENTS DETAILS (display only) ── */}
              {menuDetail && (
                <div className="p-col-12">
                  <div className="card card-w-title">
                    <div
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                      onClick={this.toggleMenuDetail}
                    >
                      <h1>Menu Item With Menu Components Details</h1>
                      <Button
                        type="button"
                        icon={this.state.menuDetailExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
                        className="p-button-text"
                      />
                    </div>
                    {this.state.menuDetailExpanded && (
                      <div>
                        <div><b>Menu Item:</b> {menuDetail.menuItemName}</div>
                        <div className="mt1">
                          <b>Menu Components:</b>{' '}
                          {menuDetail.components.length > 0 ? menuDetail.components.join(', ') : '-'}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ── RECIPE DETAIL TABLE ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1>Ingredients</h1>
                    <Button
                      label="Add Row"
                      icon="pi pi-plus"
                      className="p-button-sm"
                      onClick={this.addDetailRow}
                    />
                  </div>

                  <DataTable value={this.state.recipeDetailRows.filter((row) => !row.recipeDetailId || (row.ingredientId !== null && row.ingredientId !== undefined && row.ingredientId !== ''))}>

                    <Column
                      header="Ingredient"
                      body={(row) => (
                        <Dropdown
                          options={this.props.ingredientList}
                          value={String(row.ingredientId)}
                          onChange={(e) => this.updateDetailRow(row.id, 'ingredientId', e.value)}
                          placeholder="Select Ingredient"
                          style={{ width: '200px' }}
                          {...DROPDOWN_CONFIG}
                        />
                      )}
                    />

                    <Column
                      header="Area"
                      body={(row) => (
                        <Dropdown
                          options={this.props.areaList}
                          value={String(row.area)}
                          onChange={(e) => this.updateDetailRow(row.id, 'area', e.value)}
                          placeholder="Select Area"
                          style={{ width: '160px' }}
                          {...DROPDOWN_CONFIG}
                        />
                      )}
                    />

                    <Column
                      header="Quantity"
                      body={(row) => (
                        <InputNumber
                          value={row.quantity}
                          onValueChange={(e) => this.updateDetailRow(row.id, 'quantity', e.value)}
                          placeholder="Quantity"
                          mode="decimal"
                          minFractionDigits={2}
                          inputStyle={{ width: '120px' }}
                        />
                      )}
                    />

                    <Column
                      header="UOM"
                      body={(row) => (
                        <Dropdown
                          options={this.props.uomList}
                          value={row.uomid}
                          onChange={(e) => this.updateDetailRow(row.id, 'uomid', e.value)}
                          placeholder="Select UOM"
                          style={{ width: '160px' }}
                          {...DROPDOWN_CONFIG}
                        />
                      )}
                    />

                    <Column
                      header="Action"
                      style={{ width: '70px', textAlign: 'center' }}
                      body={(row) => (
                        <Button
                          icon="pi pi-trash"
                          className="p-button-danger p-button-text"
                          onClick={() => this.deleteDetailRow(row.id)}
                        />
                      )}
                    />

                  </DataTable>
                </div>
              </div>

              {/* ── FOOTER ── */}
              <div className="p-col-12 p-lg-12">
                <FooterButton
                  access={accessButton}
                  disabled={!isEnabled}
                  type={this.state.type.toLowerCase()}
                  save={this.add}
                  reset={this.resetData}
                  to={redirectURL}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedUserDetail: state.auth.userObject,
  userDetail: state.auth.userDetail,
  loading: state.master.loading,
  error: state.master.error,
  success: state.master.success,
  tableLists: state.master.tableLists,
  menuItemList: state.keyword.MenuItem,
  menuComponentList: state.keyword.MenuComponent,
  ingredientList: state.keyword.Ingredient,
  uomList: state.keyword.uom,
  areaList: state.keyword.area,
});

const mapDispatchToProps = (dispatch) => ({
  getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
  getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
  processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
}); 

export default connect(mapStateToProps, mapDispatchToProps)(AddRecipe);